export function getVersion() {
  return "@GRADLE_PROJECT_VERSION@";
}
